import "./style.css"

const array = [
    ["Médecin", "Pharmacien", "Sage-femme", "Infirmier / IDE", "Kinésithérapeute", "Ergothérapeute", "Pédicure-podologue", "Orthophoniste", "Psychologue", "Diététicien", "Ostéopathe", "Aide soignante", "Educateur spécialisé", "Sophrologue"],
    ["Téléphone", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Visio / Teams", "Secrétariat"],
    ["Téléphone direct", "Téléphone secrétariat", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Impossible dans ce délai"],
    [],
    ["Sportifs", "Enfants", "Adolescents", "Femmes enceintes", "Personnes âgées", "Personnes en situation de handicap", "Soins palliatifs", "Douleurs chroniques", "Troubles psy / anxiété"]
]

function CheckList({ label, field, otherField, form, setForm, alertCss, multy, type }) {

    const select = (field, value) => {
        const currentArray = form[field] || [];

        let updatedArray;

        if (currentArray.includes(value)) {
            updatedArray = currentArray.filter(e => e !== value);
        } else {
            updatedArray = [...currentArray, value];
        }

        setForm({
            ...form,
            [field]: updatedArray
        });
    };

    const isChecked = (value) => {
        if (multy) {
            return (form[field] || []).includes(value);
        }
        return form[field] === value;
    };

    return (
        <div className="list_block">
            <label>{label} <span className="red">*</span></label>

            <ul>
                {array[type].map((text, idx) =>
                    <li key={idx}>
                        <button
                            type="button"
                            onClick={() =>
                                multy
                                    ? select(field, text)
                                    : setForm({ ...form, [field]: text })
                            }
                        >
                            <i className={`checkBox ${isChecked(text) ? 'checkBoxActif' : ''}`}></i>
                            {text}
                        </button>
                    </li>
                )}

                {multy ? (
                    <li>
                        <button
                            type="button"
                            onClick={() => select(field, 'AUTRE')}
                        >
                            <i className={`checkBox ${(form[field] || []).includes('AUTRE') ? 'checkBoxActif' : ''}`}></i>
                        </button>

                        <input
                            type="text"
                            placeholder="Autre"
                            readOnly={!(form[field] || []).includes('AUTRE')}
                            value={(form[field] || []).includes('AUTRE') ? form[otherField] || '' : ''}
                            onChange={(e) =>
                                setForm({ ...form, [otherField]: e.target.value })
                            }
                        />
                    </li>
                ) : (
                    <li>
                        <button
                            type="button"
                            onClick={() => setForm({ ...form, [field]: 'AUTRE' })}
                        >
                            <i className={`checkBox ${form[field] === 'AUTRE' ? 'checkBoxActif' : ''}`}></i>

                            <input
                                type="text"
                                placeholder="Autre"
                                readOnly={form[field] !== 'AUTRE'}
                                value={form[field] === 'AUTRE' ? form[otherField] || '' : ''}
                                onChange={(e) =>
                                    setForm({ ...form, [otherField]: e.target.value })
                                }
                            />
                        </button>
                    </li>
                )}
            </ul>

            <span className={`alert ${(alertCss[field] || alertCss[otherField]) ? 'alertActif' : ''}`}>
                Ce champ est obligatoire
            </span>
        </div>
    );
}

export default CheckList;